import _ from 'lodash';
import {qw, templateToString, wait} from '../util.js';
import config from '../config.js';

export const imagekitURL = function(){
    return config.IMAGEKIT_ENDPOINT+templateToString(...arguments);
}

export const imagekitStaticURL = function(){
    return config.IMAGEKIT_ENDPOINT+'simona_cherry/static/'+templateToString(...arguments);
}

export const imagekitDynamicURL = function(){
    return config.IMAGEKIT_ENDPOINT+'simona_cherry/dynamic/'+templateToString(...arguments);
}

export const hexToRgb = hex=>{
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : null;
};

export const hexToRgbStr = (hex, alpha=1)=>{
    let {r=0, g=0, b=0} = hexToRgb(hex)||{};
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getCookie = key=>{
    key += '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0)==' ')
            c = c.substring(1);
        if (c.indexOf(key)==0)
            return c.substring(key.length, c.length);
    }
    return '';
};

export const setCookie = (key, val, exdays)=>{
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    document.cookie = `${key}=${val};expires=${d.toUTCString()};path=/`;
};

export const deleteCookie = key=>{
    document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

export const blobToBase64 = async blob=>{
    let w = wait();
    let fileReader = _.assign(new FileReader(), {
        onloadend: ()=>w.resolve(fileReader.result),
    });
    fileReader.readAsDataURL(blob);
    return w.promise;
};

export const type2str = v=>{
    if (_.isString(v))
        return v;
    if (_.isNumber(v))
        return ''+v;
    if (_.isBoolean(v))
        return v ? 'true' : 'false';
    if (v?.constructor?.name=='Date')
        return +v;
    if (_.isObject(v)||_.isArray(v))
        return JSON.stringify(v);
    if (v===null)
        return 'null';
    if (v===undefined)
        return 'undefined';
    return v.toString();
};

export const str2type = (v, type)=>{
    if (!v)
        return;
    if (type===String)
        return v;
    if (type===Number)
        return +v;
    if (type===Boolean)
        return qw`true 1 y`.includes(v.toLowerCase()) ? true : false;
    if (type===Object||type===Array)
        return JSON.parse(v);
    if (type===Date)
        return new Date(+v);
    throw new Error(`Unsupported type ${type}`);
};

export const SEC = 1000;
export const MIN = 60*SEC;
export const HOUR = 60*MIN;
export const DAY = 24*HOUR;
export const WEEK = 7*DAY;
export const MONTH = 4*WEEK;
export const YEAR = 365*DAY;

export const formatDateIsrael = ms=>{
    const d = ms ? new Date(ms) : new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return `${day}/${month}/${year}`;
};

export const formatDate = ms=>{
    const d = ms ? new Date(ms) : new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return `${year}-${month}-${day}`;
}

export const formatTime = ms=>{
    const d = ms ? new Date(ms) : new Date();
    let hours = '' + d.getHours();
    let minutes = '' + d.getMinutes();
    let seconds = '' + d.getSeconds();
    if (hours.length < 2)
        hours = '0' + hours;
    if (minutes.length < 2)
        minutes = '0' + minutes;
    if (seconds.length < 2)
        seconds = '0' + seconds;
    return formatDate(+d)+` ${hours}:${minutes}:${seconds}`;
};

export const formatAge = ms=>{
    if (_.isString(ms))
        ms = +new Date(ms);
    let diff = Date.now()-ms;
    if (diff<MIN)
        return 'עכשיו';
    if (diff<HOUR)
    {
        if (diff<2*MIN)
            return 'לפני דקה';
        return `לפני ${Math.floor(diff/MIN)} דקות`;
    }
    if (diff<12*HOUR)
    {
        if (diff<2*HOUR)
            return 'לפני שעה';
        return `לפני ${Math.floor(diff/HOUR)} שעות`;
    }
    return formatTime(ms);
};

export const downloadBlob = (blob, filename)=>{
    let href = URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();        
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

export const SIMONA_USER_ID = 'u_lzvp3cj9C5LdWBvUNpOpvZ7AAzE0rqrQqAi9e4vAVgnIwV1mGwq2O9ymLlkaQR';

export const DANIEL_USER_ID = 'u_mdvpk6j8DUhq8eQKETNnphiLgl8uXD';

export const openInNewTab = url=>window.open(url, '_blank').focus();

export const extractErrorMessage = e=>{
    if (e.code=='validation_error')
        return e.extra.map(c=>c.message).join('. ');
    if (e.code&&e.message)
        return e.message;
    return 'אירעה שגיאה, נסו שוב מאוחר יותר';
};

export const obj2qs = (qs={})=>_.entries(qs)
    .map(([k, v])=>`${k}=${encodeURIComponent(v)}`)
    .join('&');
